import dayjs from "dayjs";

export type CRONTYPE = {
  DEFAULT: string;
  ScheduleType: ScheduleType;
  DefaultFormFields: Record<string, number | number[]>;
};

export type ScheduleType = "quartz" | "human";

export const CRON: CRONTYPE = {
  DEFAULT: "* * * * * ? *",
  ScheduleType: "quartz",
  DefaultFormFields: {
    daily: 1,
    monthly_day: 1,
    monthly_date: 1,
    monthly_series: 1,
    day_of_week: 1,
    weekday_select: [dayjs().weekday()],
    weekly: 1,
    yearly: 1,
  },
};

export const HUMAN: CRONTYPE = {
  DEFAULT: "0 0 0 0 0 0 0",
  ScheduleType: "human",
  DefaultFormFields: {
    daily: 1,
    monthly_day: 1,
    monthly_date: 1,
    monthly_series: 1,
    day_of_week: 1,
    weekday_select: [dayjs().weekday()],
    weekly: 1,
    yearly: 1,
  },
};
